import script from "./ContatoModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ContatoModal.vue?vue&type=script&setup=true&lang=js"

import "./ContatoModal.vue?vue&type=style&index=0&id=30a7a994&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30a7a994"]])

export default __exports__